import React from 'react';
const options = [{
  label: 'Foundation',
  text: 'A more accessible workload for participants who are building their base.'
}, {
  label: 'Standard',
  text: 'The full prescribed workload for participants ready for the complete session.'
}, {
  label: 'Mixed-level stations',
  text: 'Exercise adaptations and printable station cards from the Mixed-Level Class Toolkit.'
}];
export function WorkloadSystem() {
  return <section aria-labelledby="workload-heading" className="bg-mint" data-id="element-270" data-mp="1mp8g7indtgg7">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 py-16 md:py-24 lg:grid-cols-2 lg:gap-16" data-id="element-271" data-mp="1ro2viam54mvk">
        <div data-id="element-272" data-mp="1wgmddjrv2466">
          <h2 id="workload-heading" className="font-display text-5xl font-extrabold uppercase leading-[0.92] text-forest md:text-6xl" data-id="element-273" data-mp="1wg322lwpue14">
            The Foundation + <span className="text-gold-dark" data-id="element-274" data-mp="25hkffwiqo1m4">Standard system</span>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-forest/80" data-id="element-275" data-mp="2aekp0hesrmhz">
            Every session scales to the group that actually shows up. Choose the workload that fits, and organize
            mixed-ability classes without rewriting the session.
          </p>
        </div>
        <ol className="space-y-3" data-id="element-276" data-mp="1qea0at8xnujg">
          {options.map((o, i) => <li key={o.label} className={`flex items-start gap-4 rounded-xl border bg-white p-5 shadow-[0_2px_10px_-4px_rgba(9,40,29,0.12)] sm:p-6 ${i === 1 ? 'border-gold' : 'border-forest/10'}`} data-id="element-277" data-mp="1qgmin7ils6x1" data-mpi={i}>
              <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg font-display text-xl font-extrabold ${i === 1 ? 'bg-gold text-forest' : 'bg-forest text-gold'}`} data-id="element-278" data-mp="2e5fivg69d0xg">
                {i + 1}
              </span>
              <div data-id="element-279" data-mp="31v9pvh3wbv9s">
                <h3 className="font-display text-2xl font-extrabold uppercase text-forest" data-id="element-280" data-mp="31vrxf9w0dvx0">{o.label}</h3>
                <p className="mt-1 text-base leading-relaxed text-forest/75" data-id="element-281" data-mp="2x15k316d9taa">{o.text}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}